import QueryStringUtil from './QueryStringUtil';

const sherbertUploadString = QueryStringUtil.getValueByKey('sherbertUpload');

export const isSherbertUpload = sherbertUploadString === 'true';
